import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { checkCookies } from "../../../services";

const CreatorLandingPage = () => {
    const history = useHistory();

    useEffect(() => {
        cookiesVerify();
    }, []);

    const cookiesVerify = async () => {
        try {
            let response = await checkCookies();
            if (response.status) {
                history.push("/creator-form");
            } else {
                history.push("/creator-landing");
            }
        } catch (error) { }
    };
    const onSubmit = () => {
        window.open(`${process.env.REACT_APP_JOSH_URL}/login?path=https%3A%2F%2Fstage-creatorpro.myjosh.in%2Fcreator-form`, '_self');
    }
    return (
        <div className="creator-landing-page-wrap">
            <div className="page-content">
                <h2>Know the Influencer</h2>
                <p>Select your most famous social media platform and provide some <br /> personal details to help brands know you better  </p>
                <div className="common-btn">
                    <button onClick={onSubmit}>Login</button>
                </div>
            </div>
        </div>
    )
}

export default CreatorLandingPage;